import { useTranslation } from 'react-i18next'
import type { AppLanguage } from '../i18n'

export type SiteLang = 'RU' | 'EN'

const SITE_LANG_BY_APP_LANGUAGE: Record<AppLanguage, SiteLang> = {
  ru: 'RU',
  en: 'EN',
}

export function getSiteLang(language?: string | null): SiteLang {
  if (language === 'ru' || language === 'en') {
    return SITE_LANG_BY_APP_LANGUAGE[language]
  }

  return SITE_LANG_BY_APP_LANGUAGE.en
}

export function useSiteLang(): SiteLang {
  const { i18n } = useTranslation()
  return getSiteLang(i18n.resolvedLanguage ?? i18n.language)
}

export function getDateLocale(language?: string | null): string {
  return getSiteLang(language) === 'RU' ? 'ru-RU' : 'en-US'
}

export function getLocalizedField(
  record: object,
  field: string,
  lang: SiteLang
): string {
  const data = record as Record<string, unknown>
  const primary = data[`${field}${lang}`]
  const alternateLang = lang === 'RU' ? 'EN' : 'RU'
  const alternate = data[`${field}${alternateLang}`]
  const base = data[field]

  const toText = (value: unknown) =>
    typeof value === 'string' ? value.trim() : ''

  return toText(primary) || toText(base) || toText(alternate) || ''
}
